var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.94 54.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5b952;}.cls-2{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:4px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "clear-nightAsset 136colored") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.87,9A25.57,25.57,0,0,1,21.5,2,25.23,25.23,0,0,1,46.94,27,25.23,25.23,0,0,1,21.5,52a26.81,26.81,0,0,1-4.42-.37l1.74-2.46A26,26,0,0,0,5.07,9.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.87,9A25.57,25.57,0,0,1,21.5,2,25.23,25.23,0,0,1,46.94,27,25.23,25.23,0,0,1,21.5,52a26.81,26.81,0,0,1-4.42-.37l1.74-2.46A26,26,0,0,0,5.07,9.34Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearNight);
export default __webpack_public_path__ + "static/media/clear-night.10da86080cdf8ab805dcb093270308d3.svg";
export { ForwardRef as ReactComponent };